import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import Button from 'shared/modules/common/components/atoms/Button';
import Icon from 'shared/modules/common/components/atoms/Icon';

type Props = {
  onNextButtonPress: () => void;
  onViewListButtonPress: () => void;
};

const AutoDebitRegistrationInstructions = (props: Props) => {
  return (
    <View style={style.root}>
      <View style={style.topContainer}>
        <Text style={style.textTitle}>口座振替の申込方法</Text>
        <View style={style.listItem}>
          <Bullet text="1" />
          <View style={style.flexShrink}>
            <Text style={style.listItemText}>
              ご利用可能な金融機関をご確認ください。
            </Text>
            <Link
              label="利用可能な金融機関を確認する"
              onPress={props.onViewListButtonPress}
            />
          </View>
        </View>
        <View style={style.listItem}>
          <Bullet text="2" />
          <Text style={style.listItemText}>
            下記のボタンより、口座振替をお申し込みください。
          </Text>
        </View>
        <View style={style.listItem}>
          <Bullet text="3" />
          <Text style={style.listItemText}>
            審査完了まで2~3日かかる場合があります。最短で、お申し込み完了の翌月から口座振替をご利用いただけます。
          </Text>
        </View>
      </View>
      <View style={style.notificationCardContainer}>
        <Image
          style={style.notificationIcon}
          source={require('shared/assets/images/icons/info.png')}
        />
        <Text style={style.notificationText}>
          みずほ銀行の場合、金融機関の手続きが完了するまで10日以上かかります。そのため、毎月21日以降にお申し込みいただいた場合、お引き落としの開始はお申し込みの翌々月となります。
        </Text>
      </View>
      <Button
        title="次へ"
        onPress={props.onNextButtonPress}
        id="adr-next-button"
        style={style.button}
      />
    </View>
  );
};

const Bullet = (props: { text: string }) => (
  <LinearGradient
    colors={['#E5258C', '#823CD7']}
    /** will do an approximately 135-degree gradient */
    start={{ x: 0, y: 0 }}
    end={{ x: 1, y: 6 }}
    style={style.bullet}
  >
    <View style={style.bulletBackground}>
      <Text style={style.bulletText}>{props.text}</Text>
    </View>
  </LinearGradient>
);

const Link = (props: { label: string; onPress: () => void }) => (
  <TouchableOpacity onPress={props.onPress} style={style.linkTouchable}>
    <View style={style.linkTouchableContentWrapper}>
      <Text style={style.linkText}>{props.label}</Text>
      <View style={style.linkIconWrapper}>
        <Icon name="link-chevron" size="16" style={style.linkIcon} />
      </View>
    </View>
  </TouchableOpacity>
);

const style = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'space-between',
  },
  textTitle: {
    fontSize: 20,
    marginBottom: 32,
    fontWeight: '600',
  },
  bullet: {
    width: 32,
    height: 32,
    borderRadius: 32,
    marginRight: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  bulletBackground: {
    backgroundColor: '#FFFFFF',
    width: 28,
    height: 28,
    borderRadius: 28,
    alignItems: 'center',
    justifyContent: 'center',
  },
  bulletText: {
    fontWeight: 'bold',
  },
  listItem: {
    flexDirection: 'row',
    marginBottom: 24,
  },
  listItemText: {
    marginTop: 4,
  },
  linkTouchable: {
    marginTop: 8,
  },
  linkTouchableContentWrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  linkText: {
    color: '#e5258c',
    fontSize: 12,
  },
  linkIcon: {
    position: 'absolute',
    bottom: -2,
  },
  linkIconWrapper: {
    width: 16,
    height: 16,
    position: 'relative',
    marginLeft: 4,
  },
  flexShrink: {
    flexShrink: 1,
  },
  topContainer: {
    flex: 1,
  },
  button: {
    alignSelf: 'center',
  },
  notificationCardContainer: {
    padding: 16,
    borderRadius: 16,
    marginBottom: 24,
    backgroundColor: '#F0F0F0',
    flexDirection: 'row',
    alignItems: 'center',
  },
  notificationText: {
    fontSize: 13,
    lineHeight: 16,
    fontWeight: '300',
    color: '#2A2E32',
    flex: 1,
  },
  notificationIcon: {
    width: 24,
    height: 24,
    marginRight: 16,
  },
});

export default AutoDebitRegistrationInstructions;
